import { useCallback, useState } from 'react';

import { BoardSoundThemes, BoardThemes } from '@exports/ChessBoard';
import { useBoardSounds } from '@exports/hooks/useBoardSounds';
import { useBoardTheme } from '@exports/hooks/useBoardTheme';
import { useTheme } from '@providers/ThemeProvider';
import { OPPOSITE_THEMES, Theme } from '@providers/ThemeProvider/ThemeContext';

import { useAutoPromotion } from '@features/game/hooks/useAutoPromotion';

export type UserSettingsProps = {
  theme: Theme;
  toggleTheme: () => void;
  autoQueen: boolean;
  toggleAutoQueen: () => void;
  boardTheme: BoardThemes;
  setBoardTheme: (theme: BoardThemes) => void;
  boardSounds: BoardSoundThemes;
  setBoardSounds: (s: BoardSoundThemes) => void;
};

export function useUserSettings(): UserSettingsProps {
  const { theme, toggleTheme } = useTheme();

  const { autoPromotion, setAutoPromotion } = useAutoPromotion();

  const toggleAutoQueen = useCallback(() => {
    setAutoPromotion(autoPromotion === 'q' ? null : 'q');
  }, [autoPromotion, setAutoPromotion]);

  const { boardSounds, setBoardSounds } = useBoardSounds();

  const { boardTheme, setBoardTheme } = useBoardTheme();

  return {
    theme,
    toggleTheme,
    autoQueen: autoPromotion === 'q',
    toggleAutoQueen,
    boardTheme,
    setBoardTheme,
    boardSounds,
    setBoardSounds,
  };
}

export function useUserFakeSettings(): UserSettingsProps {
  const [theme, setTheme] = useState<Theme>('light');
  const [autoQueen, setAutoQueen] = useState(false);
  const [boardTheme, setBoardTheme] = useState<BoardThemes>('classic');
  const [boardSounds, setBoardSounds] = useState<BoardSoundThemes>('default');

  return {
    theme,
    toggleTheme: () => setTheme(OPPOSITE_THEMES[theme]),
    autoQueen,
    toggleAutoQueen: () => setAutoQueen(!autoQueen),
    boardTheme,
    setBoardTheme,
    boardSounds,
    setBoardSounds,
  };
}
